import { createFileRoute } from "@tanstack/react-router";

import { AdminSettingsPanel } from "../components/settings/AdminSettingsPanel";

function SettingsAdminRouteView() {
  return <AdminSettingsPanel />;
}

export const Route = createFileRoute("/_app/settings/admin")({
  component: SettingsAdminRouteView,
});
